import { Component, ElementRef, HostBinding } from '@angular/core';
import { SlideFragment } from './slide-fragment';
import {SlideRouterService} from './slide-router.service';
import {trigger, transition, state, animate, style} from '@angular/animations';

const CLASS_ACTIVE = 'fragment-active';
const CLASS_INACTIVE = 'fragment-inactive';

@Component({
  selector: '[slide-fragment]',
  template: '<ng-content></ng-content>',
  animations: [
    trigger('fragmentAnimation', [
      state('hide', style({ opacity: 0, transform: 'translateX(-50px)' })),
      state('show', style({ opacity: 1 })),
      transition('* => *', [
        animate('300ms ease-out')
      ])
    ])
  ]
})
export class SlideFragmentComponent implements SlideFragment {
  public element: any;

  @HostBinding('@fragmentAnimation')
  public state = 'hide';

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
  }

  show() {
    this.state = 'show';
  }

  hide() {
    this.state = 'hide';
  }
}



// WEBPACK FOOTER //
// ./src/app/slide-fragment.component.ts